
<template>
    <section class="ErrorResultOmniSearch">
        <h2 class="Title">Something went wrong while loading results.</h2>
        <span class="ReloadResults" @click="searchStore.loadPageData()">Reload Results</span>
    </section>
</template>

<script setup lang="ts">
    import { useSearchStore } from '@app/stores/useSearchStore';

    const searchStore = useSearchStore();

</script>

<style scoped lang="scss">
    .ErrorResultOmniSearch {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        text-align: center;
        @include PaddingAreas(2, 0);

        .Title {
            $color: $Grey-900;
            @include TextStyle(HeadingSmall);

            @include Breakpoint(Large, ExtraLarge){
                @include TextStyle(HeadingMedium);
            }
        }

        .ReloadResults {
            color: $Blue-700;
            cursor: pointer;
            @include TextStyle(UiLargeSemibold);
            @include PaddingAreas(1.5, 1);

            &:hover {
                color: $Blue-700;
            }
        }

    }
</style>